import { crudOperations } from './api';

const reminderService = {
  async getReminders(franchiseeId, params = {}) {
    const response = await crudOperations.get(`/reminders/${franchiseeId}`, params);
    return response.data;
  },

  async getReminderCounts(franchiseeId, params = {}) {
    const response = await crudOperations.get(`/reminders/${franchiseeId}/counts`, params);
    return response.data;
  },

  async toggleReminderStatus(franchiseeId, noteId, newStatus) {
    const response = await crudOperations.put(`/reminders/${franchiseeId}/${noteId}`, {
      reminder_status: newStatus
    });
    return response.data;
  }
};

export default reminderService;
